import React from 'react';
import { CardFooter } from '@/components/ui/card';

export interface ErpCardFooterProps {
  className?: string;
  children?: React.ReactNode;
}
const ErpCardFooter: React.FC<ErpCardFooterProps> = ({ className, children, ...props }) => (
  <CardFooter className={className} {...props}>{children}</CardFooter>
);
export default ErpCardFooter;
